var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1464_76399",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000305176,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1464_76399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 9.177C4.93064 9.177 4.85948 9.16134 4.78648 9.13C4.71348 9.099 4.64931 9.05567 4.59398 9L2.22898 6.6355C2.11798 6.5245 2.06081 6.389 2.05748 6.229C2.05381 6.06934 2.11098 5.9375 2.22898 5.8335C2.33331 5.72917 2.46364 5.677 2.61998 5.677C2.77598 5.677 2.90614 5.72917 3.01048 5.8335L4.42698 7.2395V1.1145C4.42698 0.961837 4.48431 0.828171 4.59898 0.713504C4.71364 0.598837 4.84731 0.541504 4.99998 0.541504C5.15264 0.541504 5.28631 0.598837 5.40098 0.713504C5.51564 0.828171 5.57298 0.961837 5.57298 1.1145V7.2395L6.97898 5.8335C7.09031 5.72217 7.22398 5.66834 7.37998 5.672C7.53631 5.67534 7.66664 5.72917 7.77098 5.8335C7.88898 5.9445 7.94615 6.07817 7.94248 6.2345C7.93914 6.39084 7.88198 6.5245 7.77098 6.6355L5.40598 9C5.35064 9.05567 5.28648 9.099 5.21348 9.13C5.14048 9.16134 5.06931 9.177 4.99998 9.177Z",
    fill: "#FF5334"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDown);
export default __webpack_public_path__ + "static/media/orange_down.cac5432b7756efb8183d2ddba8aafd0f.svg";
export { ForwardRef as ReactComponent };